import { render, staticRenderFns } from "./HooYu.vue?vue&type=template&id=b46d25d0&scoped=true&"
import script from "./HooYu.vue?vue&type=script&lang=js&"
export * from "./HooYu.vue?vue&type=script&lang=js&"
import style0 from "./HooYu.vue?vue&type=style&index=0&id=b46d25d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46d25d0",
  null
  
)

export default component.exports